<template>
  <v-container>
    <v-dialog overlay-opacity="0.7" v-model="dialogInformation" max-width="800px">
      <v-card class="pa-6">
        <h2><img src="img/information.png" class="mr-2"> Position Information</h2>
        <br>
        <p style="color: #3277D5; font-size: 12px; line-height: 16px;">What is Position in Group?</p>
        <p style="font-size: 16px; line-height: 21px;">Position in Group is employee position in groups.<br>
          Leader : Employee as group leader, seen in employee details.<br>
          Staff : Employee as staff.</p>
        <p style="color: #3277D5; font-size: 12px; line-height: 16px;">What is Position Visibility?</p>
        <p style="font-size: 16px; line-height: 21px;">Position Visibility is position behaviour in parent and child
          group.<br>
          If position in group is staff, Position visibility is none.<br>
          If position in group is leader, Position visibility:
          <ul>
            <li>Parent Group Only : Group Leader is visible on parent group only</li>
            <li>Parent & All Child Group : Group Leader is visible on parent group and all its child group</li>
            <li>Parent & Selected Child Group : Group Leader is visible on parent group and selected child group below
              (max 6 child group)</li>
          </ul>
        </p>
        <p style="color: #3277D5; font-size: 12px; line-height: 16px;">What is Approver Activation?</p>
        <p style="font-size: 16px; line-height: 21px;">
          Approver Activation is employee capability to become an approver in groups. The options are :
          <ul>
            <li>Not Approver : Employee is not approver</li>
            <li>Approver 1 : Employee is approver and appear only in approver 1</li>
            <li>Approver 2 : Employee is approver and appear only in approver 2</li>
            <li>Approver 1 & 2 : Employee is approver and appear both in approver 1 and 2</li>
          </ul>
        </p>
        <p style="color: #3277D5; font-size: 12px; line-height: 16px;">What is Approver Visibility?</p>
        <p style="font-size: 16px; line-height: 21px;">Approver Visibility is approver behaviour in parent and child
          group.
          <br>
          If Approver Activation is Not Approver, Approver visibility is none.
          <br>
          If Approver Activation is Approver 1,2 or 1&2, Approver visibility:
          <ul>
            <li>Parent Group Only : Approver is visible on parent group only</li>
            <li>Parent & All Child Group : Approver is visible on parent group and all its child group
            </li>
            <li>Parent & Selected Child Group : Approver is visible on parent group and selected child group below (max
              6 child group)</li>
          </ul>
        </p>


        <v-row align="center" justify-center class="mt-4">
          <v-col>
            <center>
              <v-btn color="primary" @click="dialogInformation = false">I UNDERSTAND</v-btn>
            </center>
          </v-col>
        </v-row>

      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog" max-width="900px">
      <v-form v-model="valid" ref="formData">
        <v-card class="pt-3">
          <v-card-title>
            <span class="headline ml-2">{{isEdit ? $t('edit') : $t('add')}} {{$t('position')}}</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-text-field :label="$t('position_name')" v-model="dataItem.position"
                    :rules="[...rulesMaxChar50, validator.alfaForInput]" required class="sae-required"></v-text-field>
                </v-col>
                <v-col cols="4">
                  <v-select :items="positionList" :label="$t('position_in_group')" v-model="dataItem.positionInGroup"
                    item-text="name" :rules="[rulesNew.required]" item-value="id" required class="sae-required" @change="dataItem.positionInGroup === 1 ? dataItem.positionVisibility = '' : ''"></v-select>
                </v-col>
                <v-col :cols="dataItem.positionVisibility === 2 ? 5 : 8">
                  <v-select :disabled="dataItem.positionInGroup === 1" :items="parentList" :label="$t('position_visibility')" v-model="dataItem.positionVisibility"
                    item-text="name" :rules="dataItem.positionInGroup !== 1 ? [rulesNew.required] : []" item-value="id" :required="dataItem.positionInGroup !== 1" :class="dataItem.positionInGroup !== 1 ? 'sae-required' : ''"></v-select>
                </v-col>
                <v-col cols="3" v-if="dataItem.positionVisibility === 2">
                  <v-select :rules="rules" :items="childLevel" :label="$t('child_group_level')"
                    v-model="dataItem.positionVisibilityLevel" item-text="name" item-value="id" required
                    class="sae-required"></v-select>
                </v-col>
                <v-col cols="4">
                  <v-select :items="approverList" :label="$t('approver_activation')"
                    v-model="dataItem.approverActivation" :rules="[rulesNew.required]" item-text="name" item-value="id" required
                    class="sae-required" @change="dataItem.approverActivation === 0 ? dataItem.approverVisibility = '' : ''"></v-select>
                </v-col>
                <v-col :cols="dataItem.approverVisibility === 2 ? 5 : 8">
                  <v-select :disabled="dataItem.approverActivation === 0" :items="parentList" :rules="dataItem.approverActivation !== 0 ? [rulesNew.required] : []" :label="$t('approver_visibility')" v-model="dataItem.approverVisibility"
                    item-text="name" item-value="id" :required="dataItem.approverActivation !== 0" :class="dataItem.approverActivation !== 0 ? 'sae-required' : ''"></v-select>
                </v-col>
                <v-col cols="3" v-if="dataItem.approverVisibility === 2">
                  <v-select :rules="rules" :items="childLevel" :label="$t('child_group_level')"
                    v-model="dataItem.approverVisibilityLevel" item-text="name" item-value="id" required
                    class="sae-required"></v-select>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions class="mx-6 pb-6">
            <v-row justify="center">
              <v-btn color="primary" text @click="close">{{$t('cancel')}}</v-btn>
              <v-btn :loading="loading" color="primary" @click="saveOrUpdate(dataItem)" :disabled="!valid">
                {{$t('save')}}</v-btn>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <v-dialog v-model="deleteDialog" persistent max-width="320">
      <v-card>
        <v-card-title class="headline">{{$t('delete_category')}}</v-card-title>
        <v-card-text v-if="lang === 'id'">{{$t('delete_supervisor') + 'Posisi ' + dataItem.position}}</v-card-text>
        <v-card-text v-else>{{$t('delete_supervisor') + dataItem.position + ' Position'}}</v-card-text>
        <v-card-actions class="pa-3">
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="deleteDialog = false">{{$t('cancel')}}</v-btn>
          <v-btn color="error" :loading="loading" @click="deleteComponent(dataItem)">{{$t('delete')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-row style="justify-content: start; align-items: center;">
      <v-col cols="1" style="margin-right: -70px;" @click="dialogInformation = true">
        <span class="py-5 px-5"
          style="display: flex; justify-content: center; align-items: center; border: 1px solid #3277D5; cursor: pointer; width: 36px; height: 36px; border-radius: 3px;"
          align="center">
          <img src="img/information.png">
        </span>
      </v-col>
      <v-col cols="2">
        <v-btn style="width: 100%;" right color="primary" dark @click="addItem()">{{$t('add')}} {{$t('position')}}
        </v-btn>
      </v-col>
      <v-col cols="5">
        <v-text-field :rules="[validator.alfaForInput]" :label="$t('find_position_here')"
          prepend-inner-icon="mdi-magnify" single-line v-model="search"></v-text-field>
      </v-col>
    </v-row>

    <v-data-table :loading="loading" :search="search" :items="dataList" :headers="headers" :no-data-text="$t('no_data')"
      class="elevation-1 mt-3"
      :footer-props="{ 'items-per-page-options': [10, 50, 100], 'items-per-page-text': $t('rows_per_page') }">
      <template v-slot:item.no="{ item }">{{dataList.map(function(x) {return x.id; }).indexOf(item.id) + 1}}</template>
      <template v-slot:item.status="{ item }">
        <div v-if="item.status">
          <v-icon small class="ml-3" color="success">mdi-check-circle-outline</v-icon>
        </div>
        <div v-else>
          <v-icon small class="ml-3" color="error">mdi-alert-circle-outline</v-icon>
        </div>
      </template>
      <template v-slot:item.positionInGroup="{ item }">
        {{ checkPosition(item.positionInGroup) }}
      </template>
      <template v-slot:item.positionVisibility="{ item }">
      {{ checkPositionVisibility(item.positionVisibility) }}
      </template>
      <template v-slot:item.approverActivation="{ item }">
        {{ checkApproverActivation(item.approverActivation) }}
      </template>
      <template v-slot:item.approverVisibility="{ item }">
        {{ checkApproverVisibility(item.approverVisibility) }}
      </template>
      <template v-slot:item.action="{ item }">
        <span v-if="item.schedule_code != 'x' && item.schedule_code != 'X'">
          <v-icon small class="mr-2" color="primary" @click="editedItem(item)">mdi-pencil</v-icon>
          <v-icon v-if="!item.is_default" small color="error" @click="deleteItem(item)">mdi-delete</v-icon>
        </span>
      </template>
      <template v-slot:footer.page-text="items"> {{ items.pageStart }} - {{ items.pageStop }} {{$t('of')}}
        {{ items.itemsLength }} </template>
    </v-data-table>
  </v-container>
</template>

<script>
  export default {
    name: "config-component",
    data() {
      const lang = localStorage.getItem('lang') || 'id';
      return {
        isEdit: false,
        lang: lang,
        deleteScheduleTime: false,
        dialog: false,
        deleteDialog: false,
        dialogInformation: false,
        dataList: [],
        positionList: [{
            name: "Leader",
            id: 0
          },
          {
            name: "Staff",
            id: 1
          }
        ],
        parentList: [{
            name: "Parent Group Only",
            id: 0
          },
          {
            name: "Parent + All Child Group",
            id: 1
          },
          {
            name: "Parent + Selected Child Group",
            id: 2
          }
        ],
        approverList: [{
            name: "Not Approver",
            id: 0
          },
          {
            name: "Approver 1",
            id: 1
          },
          {
            name: "Approver 2",
            id: 2
          },
          {
            name: "Approver 1 & Approver 2",
            id: 3
          }
        ],
        childLevel: [{
            name: "1 Level",
            id: 1
          },
          {
            name: "2 Level",
            id: 2
          },
          {
            name: "3 Level",
            id: 3
          },
          {
            name: "4 Level",
            id: 4
          },
          {
            name: "5 Level",
            id: 5
          },
          {
            name: "6 Level",
            id: 6
          }
        ],
        headers: [{
            text: this.$i18n.t('no'),
            value: "no"
          },
          {
            text: this.$i18n.t('position'),
            value: "position"
          },
          {
            text: this.$i18n.t('position_in_group'),
            value: "positionInGroup"
          },
          {
            text: this.$i18n.t('position_visibility'),
            value: "positionVisibility",
            align: "center"
          },
          {
            text: this.$i18n.t('approver_activation'),
            value: "approverActivation",
            align: "center"
          },
          {
            text: this.$i18n.t('approver_visibility'),
            value: "approverVisibility",
            align: "center"
            
          },
          {
            text: this.$i18n.t('action'),
            value: "action",
            align: "center"
          }
        ],
        company_id: this.$store.state.company,
        validator: this.$store.state.validator,
        baseUrl: this.$store.state.baseUrl,
        rulesNew: {
        required: (value) =>(value == 0 ? true : !!value || this.$i18n.t('required')),
        minutes: (value) => !!value || "By Minutes.",
        weekend: (value) => !!value || "Fill with 00:00",
        numberRule: (value) => {
          if (value < 0) return "Please enter a positive number";
          return true;
        },
      },
        rules2: [(value) => (value == 0 ? true : value ? value > 0 : !!value || this.$i18n.t('required'))],
        rulesMaxChar50: [
          (v) => !!v || this.$i18n.t('field_required'),
          (v) => (v && v.length < 51) || this.$i18n.t('max_50'),
        ],
        dataItem: {
          approverActivation: "",
          approverVisibility: "",
          approverVisibilityLevel: "",
          code: "",
          position: "",
          positionInGroup: "",
          positionVisibility: "",
          positionVisibilityLevel: ""
        },
        search: "",
        editedIndex: -1,
        valid: true,
        rules: [(v) => !!v || this.$i18n.t('required')],
        loading: false,
      };
    },
    methods: {
      checkPosition(value) {
        if (value === 0) {
          return "Leader"
        } else {
          return "Staff"
        }
      },
      checkPositionVisibility(value) {
        if (value === 0) {
          return "Parent Group Only"
        } else if (value === 1) {
          return "Parent + All Child Group"
        }else if(value === null){
          return '-'
        }
         else {
          return "Parent + Selected Child Group"
        }
      },
      checkApproverVisibility(value) {
        if (value === 0) {
          return "Parent Group Only"
        } else if (value === 1) {
          return "Parent + All Child Group"
        }else if(value === null){
          return '-'
        } else {
          return "Parent + Selected Child Group"
        }
      },
      checkApproverActivation(value) {
        if (value === 0) {
          return "Not Approver"
        } else if (value === 1) {
          return "Approver 1"
        } else if (value === 2) {
          return "Approver 2"
        } else {
          return "Approver 1 & Approver 2"
        }
      },

      costumHeader(actionId, action) {
        return {
          headers: {
            actionId,
            action
          }
        }
      },
      showMessage(type, msg) {
        this.$store.dispatch('nShowMessage', {
          type,
          msg
        })
      },
      async getComponent() {
        this.loading = true
        const result = await this.$store.dispatch('getPositions')
        this.loading = false
        return result
      },
      async saveOrUpdate(data) {
        if (this.isEdit) {
          this.editComponent(data)
        } else {
          this.saveComponent(data)
        }
      },
      async saveComponent(data) {
        const body = {
          code: data.position,
          position: data.position,
          positionInGroup: data.positionInGroup,
          positionVisibility: data.positionInGroup !== 1 ? data.positionVisibility : null,
          positionVisibilityLevel: data.positionVisibility === 2 ? data.positionVisibilityLevel : null,
          approverActivation: data.approverActivation,
          approverVisibility: data.approverActivation !== 0 ? data.approverVisibility : null,
          approverVisibilityLevel: data.approverVisibility === 2 ? data.approverVisibilityLevel : null
        }
        this.loading = true
        const result = await this.$store.dispatch('savePositionCategory', body)
        this.loading = false
        if (result) {
          this.showMessage('success', this.$i18n.t('alert_save'))
          this.dialog = false
          this.dataList = await this.getComponent()
        }
      },
      async editComponent(data) {
        this.loading = true
        const body = {
          id: data.id,
          code: data.code,
          position: data.position,
          positionInGroup: data.positionInGroup,
          positionVisibility: data.positionInGroup !== 1 ? data.positionVisibility : null,
          positionVisibilityLevel: data.positionVisibility === 2 ? data.positionVisibilityLevel : null,
          approverActivation: data.approverActivation,
          approverVisibility: data.approverActivation !== 0 ? data.approverVisibility : null,
          approverVisibilityLevel: data.approverVisibility === 2 ? data.approverVisibilityLevel : null
        }
        const result = await this.$store.dispatch('editPositionCategory', body)
        this.loading = false
        if (result) {
          this.showMessage('success', this.$i18n.t('alert_edit'))
          this.dialog = false
          this.dataList = await this.getComponent()
        }
      },
      async deleteComponent(data) {
        this.loading = true
        const result = await this.$store.dispatch('deletePositionCategory', data)
        this.loading = false
        if (result) {
          this.showMessage('success', this.$i18n.t('alert_delete'))
          this.deleteDialog = false
          this.dataList = await this.getComponent()
        }
      },
      addItem() {
        this.isEdit = false
        this.dialog = true;
      },
      close() {
        this.dialog = false;
      },
      editedItem(item) {
        // eslint-disable-next-line no-console
        // console.log(item)
        this.isEdit = true
        this.dataItem = Object.assign({}, item);
        this.dialog = true
      },
      deleteItem(item) {
        this.dataItem = Object.assign({}, item);
        this.deleteDialog = true;
      },
    },
    async created() {
      this.dataList = await this.getComponent()
    },
    watch: {
      dialog(show) {
        if (show && !this.isEdit) {
          if (this.$refs.formData) {
            this.$refs.formData.reset();
            this.dataItem = {
              id: 0,
              code: '',
              name: ''
            }
          }
        }
      },
    },
  };
</script>